import styled from "styled-components";

export const InspectionListScrollContainer = styled.div`
  mask: linear-gradient(
      to right,
      transparent 0%,
      black 10px,
      black calc(100% - 10px),
      transparent 100%
    )
    0px 0px / 100% 100% no-repeat;

  height: 100%;
  overflow-x: auto;
  overflow-y: hidden;
`;

export const Container = styled.div`
  padding: 0 10px;
  display: flex;
  gap: 20px;
  flex-direction: row;
  height: 100%;
  width: fit-content;
`;

export const Column = styled.div<{
  color?: string;
  background?: string;
}>`
  display: flex;
  flex-direction: column;
  width: 430px;
  max-height: 100%;
  border-top: 4px solid ${(props: any) => props.color || "#000"};
  border-radius: 5px;
  background-color: white;
  margin-bottom: 10px;

  @media only screen and (max-width: 768px) {
    width: 345px;
  }
`;

export const ColumnFallback = styled(Column)`
  background-color: rgba(229, 229, 229, 0.7);
  animation: background-color-change 3s infinite;
  @keyframes background-color-change {
    0% {
      background-color: rgba(229, 229, 229, 0.7);
    }
    50% {
      background-color: rgba(229, 229, 229, 0.4);
    }
    100% {
      background-color: rgba(229, 229, 229, 0.7);
    }
  }
`;

export const Counter = styled.div`
  margin-left: 8px;
  padding-left: 6px;
  padding-right: 6px;
  padding-top: 2px;
  padding-bottom: 2px;

  /* Mediumgrijs */
  background: #e5e5e5;
  border-radius: 5px;

  font-size: 10px;

  display: flex;
  align-items: center;
  text-align: center;

  /* Donkergrijs */
  color: #212529;
`;

export const ColumnHeader = styled.div`
  padding: 13px 20px 0px 20px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 120%;

  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const ColumnContent = styled.div<{
  hideTopFade?: boolean;
  hideBottomFade?: boolean;
  hideScrollFade?: boolean;
}>`
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;

  mask: ${(props) =>
    props.hideScrollFade
      ? "unset"
      : `linear-gradient(
        to bottom,
        ${props.hideTopFade ? "black" : "transparent"} 50%,
        black
      )
      0px 0px / calc(100% - 15px) 15px,
    linear-gradient(black, black) 0 14px / 100% calc(100% - 28px),
    linear-gradient(
        to top,
        ${props.hideBottomFade ? "black" : "transparent"} 50%,
        black
      )
      0px 100% / calc(100% - 15px) 15px;`}

  mask-repeat: no-repeat;
`;

export const ColumnFooter = styled.div`
  padding: 0px 20px 10px 20px;
`;

export const TaskList = styled.div`
  padding: 15px 20px 15px 20px;
  box-sizing: border-box;
  width: 430px;
  display: flex;
  gap: 15px;
  flex-grow: 1;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  transition: background-color 0.3s ease;

  @media only screen and (max-width: 768px) {
    width: 345px;
  }
`;

export const ButtonContainer = styled.div<any>`
  flex-grow: 1;
  display: "flex";
  flex-direction: "row";
  gap: "8px";
`;
